module.exports = {"menuToggle":"Toggle menu","home":"Home","voicecaddie":"Voice Caddie","alarm":"Alarm","clubBi":"Golf Club BI"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/header.json
// module id = NZ3g
// module chunks = 2